import { ObjectToPost } from '@/project/views/SigningChecklistAdd.vue'

export const ENVELOPE_RECIPIENTS_MAX_COUNT = 99

export function getRemainingAvailableRecipientsCount (objectToPost: ObjectToPost) {
  const { signers, witnesses } = objectToPost
  const currentRecipientsCount = [
    ...signers.flat(),
    ...(witnesses || []).map(witness => witness.witness).flat(),
  ].length

  return Math.max(ENVELOPE_RECIPIENTS_MAX_COUNT - currentRecipientsCount, 0)
}

export function canAddRecipientOnEnvelope (objectToPost: ObjectToPost) {
  return getRemainingAvailableRecipientsCount(objectToPost) > 0
}
